/**
 * What a placed order's backend `status` means to the guest who placed it.
 *
 * The same rule in all three menu apps (see ai-work/web-order-notifications/order-status-plan.md):
 * BarApp, dashboard and Hype POS accepts all set `completed`, and the dashboard shows `on-hold` as
 * accepted too; a decline sets `cancelled`. `refunded` gets no badge here — the order sheet already
 * says "Refunded" through the payment summary, and saying it twice reads as two events.
 *
 * Anything else (`pending`, `awaiting-payment`, nothing yet) shows no badge: a guest only ever
 * sees orders that were submitted, so those would be stale or in-between reads, not news.
 */
export type OrderStatusKind = 'waiting' | 'accepted' | 'declined';

export function orderStatusKind(status: string | null | undefined): OrderStatusKind | null {
  switch (status) {
    case 'processing':
      return 'waiting';
    case 'completed':
    case 'on-hold':
      return 'accepted';
    case 'cancelled':
    case 'failed':
      return 'declined';
    default:
      return null;
  }
}

/** Translation key for a kind, under `orderStatus` in the i18n files. */
export function orderStatusLabelKey(kind: OrderStatusKind): string {
  return `orderStatus.${kind}`;
}
